<template>
    <form @submit.prevent="submit">
        <div class="grid grid-cols-5 gap-x-3">
            <FieldWithLabel
                class="col-span-2"
                label="區號"
                placeholder="電話區號"
                v-model="form['country_code']"
                type="select"
                :disabled="disabled"
                :options="countryCodeOptions"
            />
            <FieldWithLabel
                id="tel"
                class="col-span-3"
                v-model="form['identity']"
                label="電話號碼"
                placeholder="電話號碼"
                :disabled="disabled"
            />
        </div>

        <FieldWithLabel
            id="password"
            type="password"
            v-model="form['password']"
            label="密碼"
            placeholder="密碼"
            :disabled="disabled"
        />

        <p class="mb-4 text-sm font-bold text-primary desk:text-right">
            <nuxt-link :to="localePath('/auth/forgot')" class="desk:hover:underline">忘記密碼？</nuxt-link>
        </p>

        <button type="submit" class="btn h-12 w-full text-base" :disabled="disabled">
            {{ disabled ? "登入中..." : "登入" }}
        </button>

        <p class="mt-5 text-center text-sm font-bold text-primary">
            <nuxt-link :to="localePath('/auth/register')" class="desk:hover:underline">沒有帳號？立即註冊</nuxt-link>
        </p>
        <p class="mt-3 text-center text-xs text-gray-500">
            <nuxt-link :to="localePath('/teams/policies/privacy')" class="desk:hover:underline">隱私政策</nuxt-link>
        </p>
    </form>
</template>

<script>
export default {
    props: {
        disabled: Boolean,
    },
    data() {
        return {
            form: {
                country_code: this.defaultCountryCode,
            },
        };
    },
    methods: {
        submit() {
            this.$emit("submit", this.form);
        },
    },
};
</script>

<style lang="scss" scoped></style>
